export enum KeycloakRealmRole {
    DEFAULT_USER = "default-roles-zapper",
}
